import React from "react"

export interface FormContactCortexBlockProps {}

const FormContactCortexBlock: React.SFC<FormContactCortexBlockProps> = () => {
  return (
    <div className="container-full">
      <h3 className="u-text-center subtitle-section">Contact Us</h3>

      <div className="u-text-center">
        <a
          href="https://couger.co.jp/contact.html"
          target="_blank"
          rel="noreferrer"
          className="btn-contact"
        >
          Inquiry Form
        </a>
      </div>
    </div>
  )
}

export default FormContactCortexBlock
